// extracted by mini-css-extract-plugin
export default {"container":"vP-z","topReviewHeading":"wP-z","criticalReview":"xP-z","favorableReview":"yP-z","vsSeparator":"zP-z"};